import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  FormGroup,
  FormText,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import axiosConfig from "consts/axiosConfig";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { registerRs } from "consts/Constants";
import "react-datepicker/dist/react-datepicker.css";
import { Lang } from "consts/localization";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { MultiSelect } from "react-multi-select-component";

const schema = yup
  .object({
    title: yup.string().required(Lang.emptyFieldError),
    desc: yup.string().nullable(),
    link: yup.string().nullable(),
    date: yup.string().required(Lang.emptyFieldError),
  })
  .required();
export default function AddAppointmentModal(props) {
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const [loading, setLoading] = useState(false);
  const [frequency, setFrequency] = useState("0");
  const [selectedReminders, setSelectedReminders] = useState([]);
  const [endDate, setEndDate] = useState(null);

  const onSubmit = (data) => {
    console.log(errors);
    data.frequency = frequency;
    data.selectedReminders = JSON.stringify(selectedReminders);
    if (data.frequency !== 0) {
      if (endDate) {
        data.end = moment(endDate).format("yyyy-MM-DD HH:mm");
      }
    }
    data.date = moment(data.date).format("yyyy-MM-DD HH:mm");
    setLoading(true);
    axiosConfig
      .post("cases/appointments/store/" + props.caseData.id, data)
      .then((res) => {
        if (!res.data.hasError) {
          props.toggleModal(false);
          props.getItem();
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    reset(props.currentModel);
  }, [reset, props.currentModel]);

  const createInputs = (
    name,
    label,
    placeHolder,
    type = "text",
    disabled = false
  ) => {
    return (
      <FormGroup key={name}>
        <label className="form-control-label" htmlFor={`input-${name}`}>
          {label}
        </label>
        <Input
          id={`input-${name}`}
          placeholder={placeHolder}
          type={type}
          disabled={loading || disabled}
          {...registerRs(name, register)}
        />
        <FormText color="danger">{errors[name]?.message}</FormText>
      </FormGroup>
    );
  };
  const renderEndsAtDate = () => {
    if (frequency !== "0") {
      return (
        <Col lg={6}>
          <FormGroup>
            <label className="form-control-label">Ends At</label>
            <ReactDatePicker
              showIcon
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              showTimeSelect
              dateFormat="yyyy-MM-dd HH:mm"
              className="form-control"
            />
          </FormGroup>
        </Col>
      );
    }
  };
  return (
    <Modal isOpen={props.showModal} size="md">
      <ModalHeader>{props.title}</ModalHeader>
      {loading ? (
        <div className="d-flex flex-row jc-center ai-center m-4">
          <Spinner />
        </div>
      ) : (
        <Form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <Row>
              <Col lg={6}>{createInputs("title", "Title", "Title")}</Col>
              <Col lg={6}>{createInputs("link", "Link", "Link")}</Col>
              <Col lg={12}>
                <FormGroup>
                  <label className="form-control-label">Reminders</label>
                  <MultiSelect
                    options={[
                      { value: 0, label: "One hour before" },
                      { value: 24, label: "24 hours before" },
                      { value: 1, label: "Previous day, 9 AM" },
                      { value: 2, label: "2 days before, 9 AM" },
                      { value: 3, label: "3 days before, 9 AM" },
                      { value: 4, label: "4 days before, 9 AM" },
                      { value: 5, label: "5 days before, 9 AM" },
                      { value: 6, label: "6 days before, 9 AM" },
                      { value: 7, label: "7 days before, 9 AM" },
                    ]}
                    value={selectedReminders}
                    onChange={setSelectedReminders}
                    labelledBy="Select"
                  />
                </FormGroup>
              </Col>
              <Col lg={12}>
                <FormGroup>
                  <label className="form-control-label">Recurring</label>
                  <Input
                    disabled={props.loading}
                    type="select"
                    defaultValue="0"
                    value={frequency}
                    onChange={(e) => setFrequency(e.target.value)}
                  >
                    <option value="0">Never</option>
                    <option value="1">Every Day</option>
                    <option value="7">Every Week</option>
                    <option value="14">Every Weeks</option>
                    <option value="30">Every Month</option>
                    <option value="365">Every Year</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col lg={frequency !== "0" ? 6 : 12}>
                <FormGroup>
                  <label className="form-control-label">Date</label>
                  <Controller
                    control={control}
                    name="date"
                    render={({ field }) => (
                      <ReactDatePicker
                        showIcon
                        autoComplete="off"
                        selected={field.value ? new Date(field.value) : null}
                        onChange={(date) => field.onChange(date)}
                        name="date"
                        showTimeSelect
                        dateFormat="yyyy-MM-dd HH:mm"
                        className="form-control"
                      />
                    )}
                  />{" "}
                  <FormText color="danger">{errors.date?.message}</FormText>
                </FormGroup>
              </Col>
              {renderEndsAtDate()}
              <Col lg={12}>
                {createInputs("desc", "Description", "Description", "textarea")}
              </Col>
            </Row>
          </ModalBody>
          {loading ? (
            <ModalFooter>
              <div
                className="d-flex ai-center jc-center"
                style={{ width: "100%" }}
              >
                <Spinner animation="border" />
              </div>
            </ModalFooter>
          ) : (
            <ModalFooter>
              <Button
                color="secondary"
                onClick={() => props.toggleModal(false)}
              >
                Discard
              </Button>
              <Button disabled={loading} color="primary" type="submit">
                Save
              </Button>
            </ModalFooter>
          )}
        </Form>
      )}
    </Modal>
  );
}
